/*英语*/
const en_US = {
    notify: {
        success: 'success',
        warning: 'warning',
        error: 'error',
    },
    langsOptions: {
        en_US: 'English',
        hi_IN: 'हिंदी',
        zh_CN: 'Chinese',
    },
    ThirdParty: {
        title: 'Third party login',
        ways: {
            Google: 'Google',
            Facebook: 'फेसबुक खाता',
            Twitter: 'Twitter'
        }
    },
    redpack: {
        Record: 'Record',
        tips1: 'Come and try your luck',
        GETITNOW: 'GET IT NOW',
        ListofWinners: 'List of Winners',
        tips2: 'Terms and Conditions',
        desc1: 'Reload bonus - top prize up to INR 11,111',
        desc2: 'Make every deposit with a minimum of INR 500 and continue to earn.Turnover of 1(time)(s) (deposit + bonus) applies before the withdrawal .',
        desc3: 'Receive your deposit bonus automatically.',
        desc4: 'The more amount you deposit per transaction, the more amount you earn.',
        desc5: 'Click “Gift box” on the website right away after every successful deposit made, NOT allow delayed claims. ',
        desc6: 'Enjoy more games!',
        Copyright: 'Copyright © EK.BET Reserved',
        player: 'player'
    },
    pageTab: {
        Home: 'होम',
        Discounts: 'Promotion',
        Deposit: 'जमा।',
        Service: 'Customer',
        My: 'खाता',
        onlineCustomer: 'Online Service',
        tab4Txt: 'Profile',
        Withdrawal: 'वापसी'
    },
    header: {
        title: 'India Lottery',
        login: 'लॉग इन करें',
        register: 'रजिस्टर करें',
        service: 'Customer Support',
    },
    newsTitle: ['Deposits Notice', 'Maintenance Notice', 'Abnormal Occurrence', 'Special Promos', 'Winner Announced',
        'Special Notice', 'Special Recommends'
    ],
    register: {
        Cannotincludenumber: 'नंबर शामिल नहीं किया जा सकता',
        rebate: "Rebate ratio setting",
        rebatePlace: "Please enter a value not less than 0  ",
        username: 'Username / Phone Number',
        usernamePlace: 'containing 6-12 letters、number or combination',
        usernamePlace1: 'Please enter Username / Phone Number',
        passwordPlace1: 'कृप्या पासवर्ड भरें',
        userError: 'Please enter 6~12 letters, numbers or a combination of letters and numbers',
        password: 'पासवर्ड',
        passwordPlace: 'containing 6-12 letters、number or combination',
        passwordError: 'Please enter a password with 6~12 letters, numbers or a combination of letters and numbers',
        repeatPassword: 'पासवर्ड की पुष्टि कीजिये',
        repeatPasswordPlace: 'Please type password again',
        phone: 'Phone Number',
        phonePlace: 'Please type phone number',
        phoneTips: 'Please provide correct phone number to authenticate',
        agentCode: 'एफिलिएट आईडी',
        agentCodePlace: 'leave this field empty if no affiliates ID',
        vrifyCode: 'Validation code',
        vrifyCodePlace: 'Validation',
        rule: 'I agree',
        userRegistrationAgreement: '「User registration agreement」',
        loginbtn: 'लॉग इन करें',
        existingAccount: 'Already have an account?',
        confirmTitle: 'success registered. Claim your cash bonus after real - name verification',
        authenticateNow: 'Get Verified Now',
        certifyLater: 'Get Verified later',
        successTips: 'Congratulations! New Register',
        successTips2: 'Welcome to GAMESTECH!',
        bankPart1: 'You can also..',
        bankPart2: 'bind bank account',
        bankPart3: 'Available for you to withdraw money anytime',
        startGame: 'Play Games',
        startDeposit: 'Deposit',
        remember: 'Remember me',
        require: 'आवश्यक',
        noRequire: 'not required',
        realName: 'वास्तविक नाम',
        realNamePlace: 'please enter real name',
        qq: 'QQ',
        qqPlace: 'please enter QQ account',
        qqError: 'Please enter the QQ number whose first digit cannot be 0',
        wechat: 'Wechat',
        wechatPlace: 'please enter wechat',
        wechatError: '5 or more letters, numbers, underscores or minus signs, starting with a letter',
        email: 'ईमेल',
        emailPlace: 'please enter correct email',
        withdrawPassword: 'Withdrawal Password',
        withdrawPasswordPlace: 'please enter withdrawal password',
        loginTips1: "New Customer? ",
        loginTips2: "Open New Account",
        loginTips3: "In order to place bet(s) you must be a registered user",
        loginTips4: "By proceeding you confirm you are 18 years of age or older.",
        loginTips5: "Let's activate your account! ",
        loginTips6: "You have successfully created your account! To unlock your welcomeoffer and start playing, check your email and click the activation link.",
        registerBtn: 'Register Now',
        registerBtn1: 'SignUp',
        signUp: 'Create New Account',
        signUp1: 'Sign Up',
        login: 'Sign in',
        signUp2: "Open Account",
        loginTitle: "Welcome back",
        join: "अब शामिल हों",
        registerTitle: 'रजिस्टर खाता',
        registered: "Registration Completed",
        agentID: 'रेफरल पहचान',
        agentTips: 'If you have a referrer ID, please enter it here',
        forgotUsername: 'क्या यूजर नाम भूल गए है',
        forgotTip: 'Contact the customer service by clicking the button below to find back the account',
        lookfor: 'Look for the account',
        forgotPassword: 'पासवर्ड भूल गए',
        joinEkbet: 'अब EK.BET से जुड़ें!',
        GeneralInformation: 'General Information',
        AgentID: 'Agent ID',
        AgentIDTaken: 'This Agent ID is taken',
        must1: '5~13 अल्फ़ान्यूमेरिक होना चाहिए',
        must2: 'पासवर्ड 8 ~ 20 अल्फ़ान्यूमेरिक होना चाहिए।',
        pleaseEnter: 'कृपया अपना पूरा नाम अपनी सरकारी आईडी के समान ही दर्ज करें, क्योंकि सभी बैंक लेन-देन केवल नाम मेल खाने पर ही संभव हो पाएगा ।',
        ContactNumber: 'संपर्क नंबर',
        validationImg: 'कृपया छवि में दिखाया गया सत्यापन कोड दर्ज करें।.',
        phoneCodeError: '6 अंक ओटीपी',
        AffiliateID: 'Affiliate ID',
        enteragentcode: 'Please enter agent code',
        tips1: 'पासवर्ड 8 ~ 20 अल्फ़ान्यूमेरिक होना चाहिए।',
        tips2: 'Please re-enter your password',
        RegistionCompleted: 'Registion Completed',
        Application: 'Application submitted, please wait for review',
        sendCode: "ओटीपी",
        phoneCode: "6 अंक ओटीपी",
        OTP: 'OTP',
        LoginPassword: 'लॉगिन पासवर्ड',
        ReferralIDOptional: 'रेफरल आईडी (वैकल्पिक)',
        Completepersonalinformation: 'संपूर्ण व्यक्तिगत जानकारी',
        Alreadyhaveanaccount: 'क्या आपके पास पहले से एक खाता मौजूद है',
    },
    ValidTips: {
        name: 'real name verification done，',
        phone: 'phone verification done ，',
        email: 'email verification done，',
        conactService: 'please contact livechat for any change ！',
        noPhone: 'Invalid Phone Verification,Please Proceed For Manual Verification',
        noDrawPwd: 'no withdrawal password,please set up',
        noPhoneDrawPwd: 'Invalid Phone Verification,no withdrawal password,please complete all information',
        noPhoneDrawPwd2: "Please fill up mobile number and withdrawal pin before binding bank account"
    },
    download: {
        title: '',
        app: 'APP',
        appDownload: 'The Mobile App',
        subTitle: 'Safety | Reliable| Fast',
        downloadNow: 'Download',
        iPhoneDownload: 'iPhone Download',
        iPhoneDownloadTip: 'Compatible with iOS 12.0 or higher',
        androidDownload: 'Android Download',
        androidDownloadTip: 'Compatible with Android 6.0 or higher',
        tip: 'We recommend Chrome, or contact customer service if you have any problem.'
    },
    nav: {
        HotGame: 'Top Hits',
        Sport: 'Sports',
        Live: 'Live Games',
        CatchFish: 'Catch Fish',
        Slot: 'Slots',
        Lottery: 'Lottery',
        CardGame: 'Card Game',
        Affiliate: 'सहबद्ध'
    },
    agency:{
        myteam: 'मेरी टीम',
        CopyLink: 'लिंक की प्रतिलिपि करें',
        WithdrawAccount: 'सभी कमीशन मेरे खाते से निकाल लें',
        YourWithdrawrequestissent: 'आपका निकासी अनुरोध भेज दिया गया है.',
          Nocommissionavailable: 'कोई कमीशन उपलब्ध नहीं है, कृपया बाद में पुनः प्रयास करें।',
          Formodification: 'संशोधन के लिए कृपया ग्राहक सेवा पर आगे बढ़ें।',
          Setsubordinatecommmision: 'अधीनस्थ आयोग निर्धारित करें',
          Youhaveapproval: 'आपने एजेंट बनने के लिए आवेदन किया है, कृपया अनुमोदन की प्रतीक्षा करें',
        Viewmycommissionrate: 'मेरी कमीशन दर देखें',
        title: 'हमारे बारे में और जानें',
        AFFILIATE: 'संबद्ध कार्यक्रम',
        Sign:'साइन अप करें और कमाएँ',
        supply1:'यदि आपके पास एक बड़ा दर्शक वर्ग और अनुयायी हैं। आपके रेफरल कार्यक्रम को अनुकूलित करने के लिए हमारे पास आपके लिए विशेष शर्तें हैं!',
        supply2:'यदि आप खिलाड़ियों को आमंत्रित कर सकते हैं, तो आपको अपना स्वयं का अनुकूलित कैसीनो मिलेगा! आप अपने डोमेन और डिज़ाइन शैली के साथ एक कैसीनो वेबसाइट स्थापित कर सकते हैं।',
        Contact:'संपर्क करें',
        Send:'अब भेजें',
        contactTitle:'कृपया अधिक जानकारी के लिए हमसे संपर्क करें',
        FAQ:'अक्सर पूछे जाने वाले प्रश्नों',

        home:{
            CurrentReferredCommission:'वर्तमान संदर्भित आयोग',
            Withdraw:'निकालना',
            tips:'कमीशन को किसी भी समय हमारे आंतरिक वॉलेट में निकाला जा सकता है।',
            TotalCommisionEarned:'अर्जित कुल कमीशन',
            MyTeamNumbers:'मेरी टीम संख्या',
            Set:'अधीनस्थ आयोग निर्धारित करें'

        },
        team:{
            title:'मेरी टीम',
            More:'अधिक',
            text:{
                subFirst:'नए दोस्त',
                subFirstDeposit:'पहला जमा',
                subDeposit:'खिलाड़ियों को जमा करें',
                subWithdraw:'खिलाड़ियों को वापस लें',
                subTotalBonus:'बक्शीश',
                subTotalWinLoss:'हार को जीत में बदलो',
                subTotalDeposit:'जमा राशि',
                subTotalWithdraw:'राशि वापस ले',
            },
        },

        Friends:{
            title:'मित्र प्रबंधन',
            FriendsNumber:'मित्र संख्या',
            Account:'खाता',
            RegistrationDate:'पंजीकरण की तारीख',
            Deposit:'जमा',
            Withdraw:'निकालना',
            Bonus:'बक्शीश',
            ValidBets:'वैध दांव',
            WinLoss:'हार को जीत में बदलो',
        },
        Commission:{
            title:'कमीशन प्राप्त हुआ',
            Rewards:'आयोग पुरस्कार',
            Status:{
              0:'लंबित',
              1:'लेखा परीक्षित',
              2:'आवेदन',
              3:'सफलता',
              4:'अस्वीकृत',
              5:'पहले ही आ चुका',
            },
        },

        Withdraw:{
            title:"पुरस्कार वापस लें",
            title2:'कुल कमीशन निकासी',
            CommissionWithdraw:'कमीशन वापस लेना',
            Amount:'मात्रा'
        },

        Cancel:'रद्द करन',
        Search:'खोज',

    },
    agencyLogin:{
        username:'उपयोगकर्ता नाम / फ़ोन नंबर',
        password:'लॉगिन पासवर्ड',
        verificationCode:'सत्यापन कोड',
    },
    agencyRegister:{
        title:'सहबद्ध आवेदन करें',
        agentSubtitle:'सामान्य जानकारी',
        agentID:'रेफरल मित्र आईडी',
        whatsapp:'WhatsApp',
        // agentCode:'Affiliate ID',
        agentCode:'संबद्ध आईडी/रेफ़रल आईड',
        username:'प्लेयर आईडी',
        password:'लॉगिन पासवर्ड',
        repeatPassword:'पासवर्ड की पुष्टि कीजिये',
        realName:'वास्तविक नाम',
        email:'ईमेल',
        phone:'फ़ोन नंबर',
        verificationCode:'विधिमान्यकरण संकेत - लिपि',
        phoneVrifyCode:'ओटीपी सत्यापन',
        success:'पंजीकरण पूरा हुआ',
        agentSuccess:'आवेदन सबमिट हो गया है, कृपया समीक्षा की प्रतीक्षा करे',
        userPlace: 'उपयोगकर्ता नाम जिसमें 6-12 अक्षर, संख्या, या संयोजन हो।',
        Friendly:'मित्रवत अनुस्मारक',
        agentId:'एजेंट आईडी',
        vrifyCode:'विधिमान्यकरण संकेत - लिपि',
        sendCode: "OTP भेजें",
        phoneCode: "6 अंकों का ओटीपी",
        phoneCodeError: '6 अंकों का ओटीपी',
        sendCodeSuccess: "मोबाइल फ़ोन सत्यापन कोड सफलतापूर्वक भेजा गया",
    },
    newinvitation:{
      title:'मित्रों को आमंत्रित करें',
      ReferralRewards:'रेफरल पुरस्कार',
      ReferralCode:'रेफरल कोड',
      ReferralLink:'सिफ़ारिश के लिंक',
      Telegram:'टेलीग्राम पर साझा करें',
      WhatsApp:'व्हाट्सएप पर साझा करें',
      TotalEarnedReward:'कुल अर्जित इनाम',
      TotalReferredFriends:'कुल संदर्भित मित्र',
      ValidFriends:'मान्य मित्र:',
      FriendsList:'मित्रों की सूची',
      Valid:'वैध',
      sagotTitle:'अपना रेफरल पुरस्कार कैसे प्राप्त करें',
      Sharetofriends:'दोस्तों के साथ साझा करें',
      shareTips: 'अपना रेफरल लिंक या कोड अपने दोस्तों के साथ साझा करें',
      LiveRewards:'लाइव पुरस्कार',
      Got:'प्राप्त',
      rewards:'पुरस्कार',
      Rules:'रेफरल पुरस्कार नियम',
      PleaseSeeFriendsList: 'कृपया मित्र सूची देखें',
      Get: 'पाना',
      Copy: 'प्रतिलिपि',
    },
    others: {
        hiSize: "INR",
        save: 'Save',
        click: "Click",
        success: "success",
        total: "Total",
        all: 'All',
        selectLang: 'Select Langes',
        CustomerService: 'Contact Customer',
        roger: 'copy that',
        monetaryUnit: '₹',
        loadingTxt: 'Loading',
        refreshTxt: 'Refreshing',
        loadmore: 'Click to load more',
        noData1: 'No more data',
        noData2: 'Sorry…. No data',
        noData3: 'No more records',
        confirm: 'Confirm',
        cancel: 'Cancel',
        Delete: 'Delete',
        next: 'Next',
        tips: 'Notification',
        refreshSuccess: 'success refresh',
        copy: 'copy',
        copySuceess: 'success copied',
        copyFail: 'fail copied',
        select: 'Please select',
        select1: 'SELECT',
        finish: 'Finished',
        close: 'Close',
        search: 'खोज',
        searchGame: 'Search for games',
        reset: 'Reset',
        startTime: 'Start time',
        endTime: 'End time',
        startDate: 'Start date',
        endDate: 'End date ',
        timeError: 'Please select the start time and end time, and the start time must be less than the end time',
        ok: 'OK',
        Popular: 'Popular'
    },
    Forms: {
        agreeTips: 'Please check the registration terms !',
        requiredFields: 'This item is required',
        gameAccount: 'Username',
        nameCheck: 'Please enter 6~12 letters, numbers or a combination of letters and numbers',
        nameCheck2: 'Please enter 6~20 letters, numbers or a combination of letters and numbers',
        phone: 'phone number',
        phoneCheck: 'Please type correct phone number',
        email: 'Email address',
        emailCheck: 'Email format error, please re-enter',
        sendCodeBefore: 'Send',
        sendCodeAfter: 'seconds',
        verifCode: 'Verification Code',
        verifCodePlace: 'Type verification code',
        oldPwd: 'Old password',
        newPwd: 'नया पासवर्ड',
        newPwdPlace: 'Please type new password',
        pwdDiff: 'The new password cannot be the same as the old password!',
        repeatPwd: 'Confirm new password',
        repeatPwdPlace: 'Please type the new password again',
        newDiff: 'password does not match',
        pwdError: 'enter password with 6~12 letters, numbers or a combination of letters and numbers',
        drawPwdError: 'enter password with 4 or more letters, numbers or a combination of letters and numbers',
        sendSuccess: 'success sent'
    },
    upload: {
        imgSize: 'MB',
        imgSizeTxt: 'Image size suggest',
        // imgType: 'Image type',
        imgType: "Support formats",
        select: '+ select upload file',
        successTips: 'Upload Success',
        errorTips: 'Size not bigger than'
    },
    service: {
        live_chat: 'Live Chat',
        whatsapp: 'Whatsapp',
        telegram: 'Telegram',
        commonProblem: 'FAQ'
    },
    discounts: {
        loading:'loading',
        joinNow:'रजिस्ट्रेशन करें',
        forever:'forever',
        join: 'DETAIL',
        Details: 'Details',
        queryresult: 'Searching result',
        userUpgrade: 'Upgrade query',
        betOrderNo: 'Please enter the bet number',
        needLoin: 'log in and find your bonus to claim',
        noDiscounts: 'no available promos!',
        moreDiscount: 'View more promos',
        getBonus: 'Receive bonus',
        discountsReceived: 'Claim Bonus',
        apply: "Apply",
        ApplyThePromotion: 'Apply the promotion?',
        tips: "Friendly reminder",
        checkPlatform: 'Please select platform',
        checkMoney: 'Please enter amount',
        checkBisnum: 'Please bet slip number',
        userInformation: {
            userAccount: 'Username',
            levelInfo: 'Current Tier',
            totalBetflow: 'Total amount betted',
            totalUpAmount: ' total tier status bonus',
            totalWeekAmount: 'total  weekly bonus',
            totalMonthAmount: 'total monthly bonus',
            nextLevelBetflow: 'Bets required for upgrade'
        },
        tips1: 'Current and Upcoming Campaigns!',
        unlogined: {
            txt1: "FANTASTIC PROMOTIONS",
            txt2: "Win amazing prizes",
            txt3: "Here you will find our latest and greatest promotions.",
            txt4: "Tailored to your taste and super easy to find.",
            txt5: "Bookmark this page and never miss an opportunity again.",

            txt6: "Check back here to find",
            txt7: "Amazing promotions",
            txt8: "Brand New Rewards",
            txt9: "Brilliant Bonuses to Claim",
            txt10: "Join now and find out more!",
            txt11: "MOST POPULAR GAMES"
        },
        promotionPeriod: 'Promotion Period: ',
        indefinite: 'Indefinite',
        pleaseLogin: 'Please login',
        close: 'Close'
    },
    // 存款
    Deposit: {
        Howtomakeadeposit: 'रुपये जमा कैसे करें',
        Images: 'तस्वीर',
        Video: 'वीडियो',
        mark: 'Recharge Amount',
        orderTip: 'Your Recharge request is sent',
        referralAmount: 'Recommended recharge amount',
        saveLimit: 'Deposits limit',
        receiptAccount: 'beneficiary account',
        receiptAccountPlace: 'enter vaild beneficiary account',
        saveMoneyNum: 'Deposits amount',
        saveMoneyNumPlace: 'enter vaild recharge amount',
        orderName: 'Remark / UTR',
        orderName2: 'depositor',
        orderNamePlace: 'enter vaild payer name',
        saveCertificate: 'transaction receipt',
        saveCertificatePlace: 'enter vaild transaction receipt',
        payTutorial: 'Payment tutorial',
        orderNumber: 'transaction number',
        receiptMoney: 'amount',
        receipt: 'payment received',
        account: 'account number',
        timer: 'Submit Time',
        finish: 'Complete',
        finish1: 'Done',
        AccountHolderName: 'खाता धारक का नाम',
        BankAccountNumber: 'बैंक खाता संख्या',
        base: {
            title: 'Recharge',
            savaType: 'Please choose payment option',
            nonsupport: 'Sorry, the payment option is not supported',
            tips: "Please choose the way you want to pay"
        },
        bankTransfer: {
            UPIID: 'UPI ID',
            title: 'Bank transfer',
            bankAddr: 'IFSC CODE',
            bank: 'bank',
            beneficiary: 'beneficiary',
            account: 'bank account',
            contactUs: 'Please contact Customer Support',
            // sendTips: 'Request has been sent',
            sendTips: 'Your recharge request is sent',
            orderMoney: 'Amount',
            orderDueBank: 'beneficiary bank',
            oderBankName: 'account name',
            transfer: 'inter-bank transfer',
            transferTips1: 'Recharge will reflect in your account 30 minutes after',
            transferTips2: 'money transfer arrivial time depends.If you did not receive the fund within 24 hours after you fund is processed, please contact Customer Support!',
        },
        Deposits: {
            title: 'Deposits',
            payType: 'payment options',
            payChannel: 'select a payment channel',
            channel: 'channel',
            bank: 'choose a bank',
            bankPlace: 'choose paying bank',
            selectMoney: 'select amount',
            saveMoney: 'Deposits amount',
            saveMoneyPlace: 'enter amount',
            fixedMoney: 'enter fixed amount',
            insufficient: 'insufficient balance',
            payOthersType: 'change other payment method',
            back: 'back',
            paySuccess: 'success loaded',
            finish: 'done payment '
        },
        Neteller: {
            title: 'Neteller',
            cost: 'FEE',
            tips: 'Your recharge request is sent'
        },
        Paytm: {
            title: 'Paytm',
        },
        Skrill: {
            title: 'Skrill'
        }
    },
    forget: {
        title: 'Forgot your password',
        RetrieveSMS: 'SMS password recovery',
        MailboxRetrieve: 'Email password recovery',
        CustomerRetrieve: 'password recovery by Customer Support',
        checking: 'Verification',
        userPlace: 'Enter your username',
        phonePlace: 'Enter the connected phone number',
        emailPlace: 'Enter the connected Email address',
        resetPwd: 'Reset password',
        tips: 'failed redirecting to page? Kindly contact Customer Support>',
        tips1: 'SMS with Verification Code has been sent to your phone. If not received, please click send verification code.',
        tips2: 'A email with Verification Code has been sent to your email address. If not received, please click send verification code.',
        tips3: 'Note: the email might be mistaken for spam; pls also check the spam folder',
        submit: 'Submit',
        successTips1: 'password recovery',
        successTips2: 'Your password was success created. '
    },
    signIn: { // 签到
        signTipsReward1: 'Sign in to send prizes',
        signTipsReward2: 'Sign-in benefits',
        surprise: 'Surprise',
        success: 'Sign successfully',
        successTips: 'Can accumulate cash~',
        daySign: 'Daily sign in',
        otherIncentives: 'other rewards',
        cashBonus: 'cash bonus',
        currentIntegral: 'Current points',
        sign: 'sign in',
        signed: 'already signned in',
        signTips1: 'You have a pending reward point.',
        signTips2: 'Consecutively signin',
        signTips3: ' Dont forget sign in today!~',
        signTips4: 'sign in for tomorrow',
        signTips5: 'Signing in tomorrow for suprise',
        Integral: 'reward points',
        signInTalent: 'Singin expert',
        awardTips1: 'congratulations！',
        awardTips2: 'Contact Customer Support to claim your real prize',
        integralChange: 'Redemption',
        integral: 'Required points',
        confirmChange: 'confirm the redemption',
        signNow: 'sign in NOW',
        gameOptions: [
            'Candy Land', 'Identity V', 'Pandora is Box', 'Dolphin', 'Girl with guns', 'Red Dragon Wild',
            'Gold Factory', 'Top Trumps Celebrities', ' Vikingmania', 'High society', 'Egyptian Goddess',
            'Zhao Cai Jing Bao',
            'Life of Riches', 'Lost Vegas', 'Big Wheel', 'Jin Ping Mei 2', 'Bull Bull chess', 'Gold Panther',
            'Super 888', 'Sushi Bar Slot', 'Age Of Discovery', 'Monkey Slot', 'Tarzan', 'Great adventure',
            'Pharaoh is tomb slot', 'Ways of fortune', 'Lucky Panda Slot', 'Fire Rooster', 'Tarzan',
            'Asian Fantasy Slot', 'Shaolin Fortunes', 'The three Kingdoms', 'Dream Date', 'Emotion coins',
            'Forbidden Throne', ' Playboy'
        ],
        choosePrize: 'Select prize',
        lackOfIntegral: 'insufficient points',
        continuously: 'consecutively signin',
        jetton: 'chip',
        size: '₹',
        signInTab: {
            integral: 'History',
            cash: 'Cash Back',
            forRecord: 'redeem history',
            rule: 'policy'
        },
        myself: 'My',
        recordTips1: 'You have a pending reward point',
        signDay: 'consecutively signin',
        day: 'day',
        dayModifier: '',
        noDataTips: 'every single point is a start of capital.'
    },
    mine: {
        depositTitle: 'प्लेयर टॉप अप',
        billDetail: {
            toady: 'आज',
            yesterday: 'कल',
            thisWeek: 'इस सप्ताह',
            lastWeek: 'पिछले सप्ताह',
            thisMonth: 'इस महीने',
            lastMonth: 'पिछला महीना',
            finalWeek: 'पिछले 7 दिन',
            finalMonth: 'पिछले 30 दिनों में',
            allType: 'सभी',
            SystemTransfer: 'सिस्टम समायोजन',
            RepaidDeposit: 'जमा करें',
            withdrawals: 'शीघ्र वापसी',
            SwitchToGame: 'गेम में आयात करें',
            GameOut: 'खेल से निर्यात करें',
            discounts: 'प्रमोशन बोनस',
            ManualDeposit: 'मैन्युअल जमा',
            ManualRemoval: 'मैन्युअल निकासी',
            Yredemption: 'हाँ मोचन भुगतान करें',
            Ypurchase: 'हाँ खरीद का भुगतान करें',
            Betting:'शर्त',
            Payout:'भुगतान',
            applying:'आवेदन',
            transNo: 'आदेश संख्या।',
            orderName: 'आदेश का शीर्षक',
            orderTime: 'समय',
            payType: 'सौदे का प्रकार',
            amount: 'मात्रा',
            status: 'स्थिति'
        },
        capital: {
            account: 'My Account',
            deposit: 'Deposit',
            bankList: 'bank account manage',
            withdrawal: 'निकासी',
            history: 'History',
            statement: 'वित्तीय रिकॉर्ड',
            lockAmount: 'Locked details',
            accountManage: 'Amount',
            latestDeposit: 'Latest Deposit',
            ContinuePayment: 'Continue Payment',
            revoke: 'revoke',
            accountin: {
                balance: 'Balacne',
                refresh: 'refresh',
                accountBalance: 'main account',
                deposit: 'deposit',
                withdraw: 'निकासी',
                takeBack: 'One Piece Back',
                AvailBalance: 'available balance',
                mainBalance: 'main',
                money: 'INR',
                RMB: 'RMB',
                describe: 'No gaming account found',
                describe2: 'No game found',
                refreshSuccess: 'Success refreshed',
                takeBacking: 'taking back',
                takeBackError: 'TakeBack error',
                gameBalance: 'Game account amount',
            },
            depositin: {
                deposit: 'deposit',
                nocheck: 'No payment options',
                limit: 'Deposit limit:',
                limit2: 'Single limit:',
                money: 'INR',
                Previous: 'Proceed',
                Recharge: 'Instant Recharge',
                returns: 'return',
                Recharge1: 'RECOMMENDED TOP UP AMOUNT',
                Recharge2: 'PLEASE TOP UP',
                Recharge3: 'TOP UP AMOUNT',
                Recharge4: 'PLEASE ENTER TOP UP AMOUNT',
                choseBank: '请选择第三方支付银行',
                done: 'Done',
                DepositDetails: 'Deposit Details',
                bank2_title: 'If you have any doubt, kindly contact [Online support]',
                bank_title: 'Please select beneficiary bank account',
                step_title: 'Your deposit request is sent',
                step2_title: 'applicable for this only. Please check next transaction.',
                bank: {
                    title1: '1st, Fill in the transfer form',
                    title2: '2rd, Complete and done',
                    copy: 'Copy',
                    Bank: 'Bank name',
                    Beneficiary: 'Beneficiary',
                    Account: 'खाता',
                    successTitle1: 'Sent cancel deposit request',
                    successTitle2: 'Inner-bank transfer： The deposited amount will reflect in your balance within 30 minutes.',
                    successTitle3: 'Inter-bank transfer：Bank does not promise remittance arrival time. If  your funds does not show up within 24 hours, please contact online support',
                    orderNumber: 'transaction no.',
                    DepositorName: 'Depositor',
                    Amount: 'Amount',
                    dialogTitle: 'Please confirm transfer information',
                    UP: 'upload receipt',
                    Confirmed: 'Confirmed',
                    copysuccess: 'success copied',
                    pleaseAmount: 'enter deposit amount',
                    pleaseName: 'enter depositor name',
                    pleaseImgUrl: 'upload receipt',
                    subsuccess: 'success',
                    suberr: 'failed'
                },
                nobank: {
                    PayGate: 'PayGate',
                    FEE: 'fee',
                    CollectionAccount: 'Receiver QR code',
                    copy: 'copy',
                    orderNumber: 'transaction no.',
                    Submmit: 'time',
                    Amount: 'amount',
                    Transfer: 'Transfer',
                },
                checkform: {
                    Depositlimit: 'Deposit limit',
                    Amount: 'Amount',
                    DepositorName: 'Remark/UTR',
                    UP: 'Upload Deposit Proof',
                    UPtips: 'Image size：1MB / format：JPG，PNG，GIF',
                    chenkAmount1: 'Please enter a positive integer',
                    chenkAmount2: 'The deposit amount cannot be less than',
                    chenkAmount3: 'The deposit amount cannot be more than',
                    UPmessage: 'Upload successfully',
                    err1: 'Upload image format is wrong!',
                    err2: 'Upload voucher size cannot exceed 1MB!',
                }
            },
            withdrawalin: {
                title: 'withdraw amount',
                amountPlace: 'enter withdraw amount',
                refresh: 'refreshed balance',
                AvailBalance: 'Available Balance：',
                amount: 'amount',
                tips: 'Allowable withdrawal more than {min} and avoid decimals',
                withdrawPassword: 'Withdraw password',
                choseBankCard: 'select bank',
                Please: 'please select',
                loading: 'loading',
                addBankCard: 'Add bank account(s)',
                tips2: 'Reminder: need withdraw password and phone verification before withdraw',
                next: 'Next',
                diatitle: 'enter withdraw password',
                diaPlace: 'Please enter withdraw password',
                confrim: 'confirm',
                confrim1Title: 'No withdraw password, do you want set a password?',
                confrim2Title: 'Need phone no. verification before withdraw, verify now?',
                confrimTips: 'Reminder',
                confirmText: 'confirm',
                cancelText: 'cancel',
                wpandmb2: 'Please fill up mobile number and withdrawal pin before binding bank account',
                wpandmb: 'add bank account need phone number verification and set up withdrawl password,continue？',
                choseBank: 'choose a bank',
                choseAmount: 'withdrawl amount ',
                choseAmount2: 'more than ',
                noBalance: 'insufficient balance',
                noPoint: 'avoid decimals',
                nopwd: 'enter withdraw password',
                withdrawalSuccess: 'Request sent, wait for approval',
                refreshSuccess: 'Success refreshed',
                addBankCardDesc: 'Kindly fill in your bank account details',
                ACCOUNTHOLDERNAME: 'ACCOUNT HOLDER NAME'
            },
            bankListin: {
                title1: 'check bank lists',
                title2: 'add bank account',
                loading: 'loading',
                tips1: 'Contact Customer Support to delete bank account, Yes or No?',
                addBankCard: 'add bank account',
                bankUser: 'card holder',
                littleTips: 'Reminder',
                nameOnce: 'Card holder name must comply with the verified real name and can only be set once. Contact Customer Support to modify if needed',
                namePlace: 'enter card holder name',
                bankNum: 'bank account',
                bankTips: 'enter a vaild bank account no. or display error',
                bankPlace: 'enter bank account no.',
                bankName: 'bank name',
                PbankName: 'choose bank',
                bankNamePlace: 'enter bank name',
                subbranch: 'IFSC CODE',
                subbranchPlace: 'enter the accounts bank branch',
                Mobile: 'bank binding phone',
                Mobiletitle: 'Must put the accounts bak phone no.',
                password: 'withdraw password',
                passwordPlace: 'enter withdraw password',
                add: 'add',
                confirmTitle: 'Need withdraw password before binding bank account, do you want set a password?',
                confirmTips: 'Reminder',
                confirmText: 'confirm',
                cancelText: 'cancel',
                Cancel: 'Cencel',
                OK: 'Confirmed',
                cantBank: 'Unable to bind bank account now ',
                addSuccess: 'Add success',
                Required: 'not empty',
                bkNbrules: 'Must be between 6~22 numbers',
                MaximumAccount: 'अधिकतम 1 बैंक खाता जोड़ा जा सकता है. कृपया संशोधित करने के लिए ग्राहक सेवा से संपर्क करें।',
                Must1: 'Must fill in 6-22 numbers'
            },
            withdrawalListlis: {
                loading: 'loading',
                search: 'खोज',
                time: 'Time',
                amount: 'Amount',
                status: 'स्थिति',
                bankName: 'bank name',
                bankNumber: 'bank account no.',
                remark: 'Remark',
                statusAll: 'All',
                applying: 'applying',
                payment: 'processing',
                success: 'success',
                reject: 'declined'
            },
            lockAmountin: {
                rechargeLock: 'deposit locked',
                allStates: 'all',
                lockIn: 'lock in',
                Unlocked: 'unlocked',
                Cancelled: 'cancelled',
                order: 'Order no.',
                principal: 'capital',
                lockInAmount: 'locked amount',
                targetFlow: 'turnover target',
                flowComple: 'turnover completed',
                lockStatus: 'lock status',
                handle: 'operate',
                deblocking: 'unlock',
                discountsLock: 'promotion lock',
                allPlatform: 'All platforms',
                mainAccount: 'main account',
                bonusName: 'bonus title',
                bonusType: 'bonus type',
                platform: 'platform',
                bonusLockStatus: 'bonus locked status',
                deblockingSuccess: 'unlocked'
            },
        },
        verifyName:{
            title:'real name and ID verification',
            subTitle1:'enter real name',
            subTitle2:'enter ID no.',
            cancel:'cancel',
            confrim: 'confirm',
            tips:'Real name and ID verification to protect your legal rights and account safety',
            nameConfrim:'real name verification',
        },
        verifyPhone:{
            title:'Bind phone no.',
            subTitle1:'enter phone no.',
            subTitle2:'enter verification code',
            sendcode:'send verification code',
            suffix: 'Resend after ____ seconds',
            cancel:'cancel',
            confrim: 'confirm',
            modify:"modify",
            modifyph:"modify phone no.",
            tips:'The above information is used to recover your account if you forget your username and password.',
            mileHadSend:'SMS sent',
            phoneConfrim:' phone no. verification ',
        },
        loginPassword:{
            title:'लॉगिन पासवर्ड बदलें',
            oldPW:'पुराना लॉगिन पासवर्ड',
            newPW:'नया लॉगिन पासवर्ड',
            confirmNew:'नए पासवर्ड की पुष्टि करें',
            subTitle1:'पुराना पासवर्ड डालें',
            subTitle2:'नया पासवर्ड दर्ज करें',
            subTitle3:'नए पासवर्ड की पुष्टि करें',
            oldPWRequired:'कृपया अपना पुराना लॉगिन पासवर्ड दर्ज करें',
            newPWRequired:'कृपया नया पासवर्ड दर्ज करें',
            confirmNewRequired:'कृपया अपना नया पासवर्ड पुष्टि करें',
            cancel:'रद्द करना',
            confrim: 'परिवर्तन',
            tips:'Remark:पासवर्ड गोपनीय रखें। यदि आप अपना पासवर्ड भूल गए हैं, तो आप पासवर्ड रिकवरी टूल का उपयोग कर सकते हैं या ग्राहक सहायता से संपर्क कर सकते हैं',
            pleaseLogin:'फिर से लॉगिन करें',
            oldpwdError:'पुराना पासवर्ड त्रुटि प्रारूप',
            pwdError: 'नया पासवर्ड त्रुटि प्रारूप',
            pswIsChange:'change login pwd',
            epeatPassword2:'पासवर्ड मैच नहीं कर रहा है'
        },
        setPassword:{
            title:'Set withdraw password',
            subTitle1:'enter verified phone no.',
            phoneFirst: 'please verify your phone no.',
            subTitle2:'enter verification code',
            subTitle3:'enter withdraw password',
            subTitle4:'confirm new password',
            sendcode:'send verification code',
            suffix: 'Resend after ____ seconds',
            cancel:'cancel',
            confrim: 'confirm',
            tips:'Remark: keep password confidential. If you forgot, please contact Customer Support' ,
            mileHadSend:'SMS sent',
        },
        changePassword:{
            title:'change withdraw password',
            subTitle1:'enter verified phone no.',
            phoneFirst: 'enter withdraw password',
            subTitle2:'enter verification code',
            subTitle3:'enter old withdraw password',
            subTitle4:'enter new withdraw password',
            subTitle5:'confirm new withdraw password',
            sendcode:'send verification code',
            suffix: 'Resend after ____ seconds',
            cancel:'cancel',
            confrim: 'confirm',
            tips:'Remark: keep password confidential. If you forgot, please contact Customer Support',
            mileHadSend:'SMS sent',
        },
        email:{
            title:'संदेश',
            mineMsg: 'My message',
            newMsg: 'latest  news',
            hasRead: 'read message',
            noMsg: 'No message' ,
            del:'delete',
            sendMsg:'Send new message',
            msgType:'Message type：',
            please:'select',
            pleaseCheck:'select question type',
            mine:'Main Subject Line:',
            minePlease: 'input a subject line',
            content: 'content:',
            contentPlaese:'input content',
            send:'Send',
            question1:'withdraw and deposit',
            question2:'प्रमोशन',
            question3:'Game related',
            question4:'other question',
            question5:'Suggestion',
            question6:'Complaint',
            checkInfo:'Delete Selected Messages',
            delSuccess:'Deleted success',
            submitSuccess:'submit success',
            finishContent:'complete filling in'
        },
        statement: 'वित्तीय रिकॉर्ड',
        gameHistory: 'Game History',
        promotion: 'Promotion',
        profile: "Profile",
        myAccount: "सभी बटुए",
        logout: "Logout",
        welcome: 'नमस्ते',
        visitor: 'visitor',
        accountManageText: 'Account manage',
        bindNow: 'Act now to bind',
        bindSuccess: 'binding success',
        filtrate: 'filter',
        timers: 'time',
        timeOptions: {
            '90': 'all',
            '1': '24 hours',
            '7': '7 days',
            '30': '1 month'
        },
        minBaseOptions1: {
            SaveMonery: 'Deposits',
            Withdrawal: 'वापसी',
            Wallet: 'Wallet',
            StationLetter: 'संदेश',
            betRecord: 'Bet Records',
        },
        minBaseOptions2: {
            drawHistory: "Draw History",
            betDetails: "Betting Details",
            helpCenter: "Help Center",
            openApp: "Open APP",
            StationLetter: 'संदेश',
            discount: 'प्रमोशन',
            task: 'Task',
            betRecord: 'Bet Records',
            merchRecord: 'Transaction Record',
            lockAmount: 'Lock Amount Details',
            gameCollect: 'My Collection',
            InviteFriends: 'Invite Friends',
            agentCenter: 'Agent Center',
            appDownload: 'Mobile',

            setting: "सेटिंग्स।",
            wallet: "सभी बटुए",
            bankManage: "Bank Account Management",
            promotion: "Promotion",
            statement: "वित्तीय रिकॉर्ड",
            gameHistory: "Game History",
        },
        Withdrawal: {
            mark: "Withdrawal Conditions",
            mainBalance: 'Main Account',
            addBank: 'add bank account',
            balance: 'शेष राशि',
            detailsTitle: 'the bank statement',
            cash: 'Cash out is available',
            recharge: 'Recharge',
            drawMoney: 'निकासी',
            platform: 'Platform',
            takeBack: 'TakeBack',
            takeBack1: 'Return',
            addbankcard: {
                pageTitle: 'bank account manage',
                tips1: 'contact Customer Support to update phone number',
                tips2: 'no transaction password, do you want set a password?',
                tips3: 'Do you want set a password for your account safety?',
                personName: 'card holder',
                personNamePlace: 'Enter the card holder real name',
                bankName: 'bank name',
                bankNamePlace: 'Please select bank name',
                cardNumber: 'bank account number',
                cardNumberPlace: 'must be 6 ~ 22 digits',
                cardNumberError: 'Please enter 6 ~ 22 digits bank card number!',
                bankBranch: 'branch code',
                bankBranchPlace: 'enter vaild branch code',
                bankBindPhone: 'Mobile No. with bank',
                bankBindPhonePlace: 'Must be the contact number registered with bank',
                withdrawPassword: 'transaction password',
                withdrawPasswordPlace: 'enter transaction password',
                realEmailAddress: 'Must be real email address.'
            },
            Draw: {
                pageTitle: 'निकासी',
                money: 'withdraw amount',
                moneyPlace: 'enter withdraw amount',
                pwd: 'withdraw password',
                pwdPlace: 'enter withdraw password',
                canDraw: 'Available Balance',
                drawTips1: 'withdraw amount more than',
                drawTips2: 'allowable',
                drawTips3: 'need withdraw password and phone verification before withdraw',
                drawTips4: ', avoid decimals',
                deleteTips1: 'delete bank account',
                deleteTips2: 'Contact Customer Support to delete bank account, Yes or No?',
                phoneTitle: 'phone number not verified',
                phoneConfirm: 'Verify NOW',
                phoneCancel: 'Verify later',
                pwdTitle: 'no withdraw password',
                pwdConfirm: 'Go setting NOW',
                pwdCancel: 'Go setting later',
                pwdInputTitle: 'enter withdraw password',
                deleteSucess: 'delete success.',
                takeBackSuccess: 'takeback success',
                applySuccess: 'apply success',
                check: {
                    amount1: 'enter interger numbr bigger than 0',
                    amount2: 'Insufficient balance',
                    pwd: 'withdraw password not empty'
                }
            }
        },
        wallet: {
            title: 'wallet',
            balance: 'balance',
            availBalance: "Available Balance"
        },
        stationLetter: {
            title: 'संदेश',
            pageTab: {
                myMessage: 'निजी सन्देश',
                sendMessage: 'Send new message'
            },
            myMessageTab: {
                unread: 'latest news',
                read: 'read message'
            },
            noMsg: 'No message',
            noMoreMsg: 'No more messages',
            deleteSelect: 'Delete Selected Messages',
            deleteSuccess: 'Deleted success',
            msgType: 'message type',
            msgTypeOptions: {
                money: 'withdraw and recharge',
                discounts: 'प्रमोशन',
                games: 'Game related',
                other: 'other question',
                proposal: 'Suggestion',
                complaint: 'Complaint'
            },
            theme: 'Main Subject Line',
            themePlace: 'input a subject line',
            desc: 'content',
            descPlace: 'input content',
            send: 'send',
            selectMsgType: 'select question type',
            sendSuccess: 'sent success'
        },
        betRecord: {
            title: 'Bet records',
            total: 'कुल',
            size: 'Transaction numbers',
            betMoney: 'Bet amount',
            effectiveBet: 'Valid amount',
            profit: 'Profits amount',
            gameType: 'Game type',
            platNumber: 'Platform code',
            betOrder: 'Bet order number',
            betTime: 'Bet time',
            settltTime: 'Settletime',
            customTime: 'self-defined time',
            selectTime: 'selected time',
            startTime: 'Start time',
            endTime: 'End time',
            timeError: 'Please select the start time and end time, and the start time must be less than the end time',
            noData: 'no slip data',
            gamelist: {
                '-1': 'All',
                '1': 'Slots',
                '2': 'Live Casino',
                '3': 'Sports',
                '4': 'Lottery',
                '5': 'Fish',
                '6': 'Card Game',
                '8': 'Other'
            }
        },
        LatestDeposit: {
            title: 'Latestrecharge',
            yes: "YES",
            no: "NO",
            continuePay: "Continue Payment",
            cancel: 'Revoke',
            dateTimes: 'Trans. Date',
            Type: 'Deposits Type',
            Amount: 'Amount',
            ID: ' Deposits ID',
            Status: 'स्थिति',
            Action: 'Action',
            confirmTips: 'Cancel your recharge',
            tipsTips1: 'Your application has been revoked!',
            tipsTips2: 'Reminder : Multiple Request Will Deemed To Account Suspended',
            Close: 'Close',
            goDeposit: 'Go to Deposits List',
            paytips1: 'You still have unapproved recharge, ',
            paytips2: 'please wait for approval or revoke your recharge ticket',
            gamelist: {
                '0': 'Processing',
                '1': 'Succeeded',
                '2': 'Failed',
                '3': 'Canceled',
            }

        },
        tradingRecord: {
            title: 'Transaction record',
            tradingType: 'Transaction types',
            tradingTypeOptions: {
                0: 'all',
                1: 'system adjustment',
                2: 'Make recharge',
                3: 'quick withdraw',
                4: 'Import to game',
                5: 'Export to game',
                8: 'Promotion Bonus',
                9: 'Manual Recharge',
                10: 'Manual Withdraw',

                11: 'lottery purchase',
                12: 'lottery payout',
                13: 'lottery order cancelled',
                14: 'lottery daily task',
                16: 'Superior agent manually add',
                17: 'Purchase Yu Er Balance',
                18: 'Redeem Yu Er Balance',
                19: 'lottery purchase',
                20: 'lottery payout',
                21: 'lottery order cancelled',

                22: 'sports bet',
                23: 'sports win/loss',
                24: 'sports bet refund',

                30: 'invitation commission',

                40: 'Betting',
                41: 'Payout',
                50: 'Rebate Payout',
                90: 'tips',
                91: 'guess bet',
                92: 'guess payout ',
                93: 'guess cancelled',

                100: 'applying',
                101: 'pending recharge',
                102: 'pending withdraw',
            }
        },
        tradingRecordDetails: {
            title: 'transaction details',
            orderNumber: 'order number'
        },
        lockAmount: {
            title: 'Lock Amount Details',
            rechargeTab: 'Deposits lock',
            discountsTab: 'promotion lock',
            platform: 'whole platform',
            platformPlace: 'select platform',
            lockStatus: 'lock status',
            lockStatusPlace: 'choose lock status',
            bonus: 'select bonus type',
            bonusType: 'bonus type',
            loackAmonutOptions: {
                all: 'all',
                lock: 'lock',
                unlock: 'unlock',
                cancel: 'cancel'
            },
            loackAmonutStatus: {
                deposit: {
                    0: 'applying',
                    1: 'success',
                    2: 'failed',
                    3: 'frozen',
                    4: 'cancel '
                },
                bonus: {
                    0: 'applying',
                    1: 'processing',
                    2: 'success claimed',
                    3: 'decline',
                    4: 'failed',
                    5: 'unclaimed',
                    6: 'not drawn'
                }
            },
            bonusTypeOption: {
                all: 'all',
                waterRebate: 'Turnover bonus',
                softLoan: 'Deposits bonus',
                rescueGold: 'Lose Rebate',
                upgradeAwards: 'VIP upgrade bonu',
                winAwards: 'Retain VIP bonus',
                otherPreferential: 'Sign up bonus',
                joinPreferential: 'Referal bonu'
            },
            platformOption: {
                all: 'All platforms',
                main: 'main account'
            },
            loackItem: {
                capital: 'capital',
                size: '₹',
                lockMoney: 'locked amount',
                waterComplete: 'turnover completed',
                waterTarget: 'turnover target',
                unlock: 'unlock',
                bonus: 'bonus title',
                moneyNum: 'amount',
                remainingWater: 'remain turnover request',
                platform: 'platform',
                unlocked: 'unlocked'
            }
        },
        invite: {
            title: 'Invite Friends',
            scan: 'scan to download APP',
            link1: 'affiliatess link',
            link2: 'Download APP',
            link3: 'Referral code',
            tips: 'use any of the register methods',
            activity: 'Promotion details',
            account: 'खाता',
            receive: 'receive',
            received: 'CLAIMED',
            cashingPrize: 'CLAIM',
            outDate: 'Expired',
            noActivity: 'no promotion',
            anyWay: 'friend can choose any of the register methods'
        },
        accountManage: {
            title: 'Account Manage',
            nickName: 'Nickname',
            name: 'वास्तविक नाम',
            phone: 'Phone Number',
            email: 'ईमेल',
            loginPwd: 'नया पासवर्ड',
            drawPws: 'नया रूपया निकासी पिन ',
            loiginOut: 'Log Out',
            authe: 'Verify Now',
            edit: 'Edit',
            setting: 'Setting',
            Registered: 'Registered',
            lastLogin: 'अंतिम लॉगइन',
            facebookAccount: 'Facebook',
            birthday: 'जन्मदिन।',
            whatsappNumber: 'व्हाट्स अप्प नंबर',
            Start: 'खेल शुरू करें',
            End: 'समाप्त',
            playerId: 'प्लेयर आईडी',
            userId: 'User ID',
            confirmTips: 'Please confirm if you want to modify your profile?',
            cancelText: 'Cancel',
            confirmText: 'OK',
            update: 'Update profile success.',
        },
        verifiedAuth: {
            title: 'real name authentication',
            tips: 'Note:After real-name authentication, no change allowed. Your withdraw account name is your real name',
            name: 'name',
            namePlace: 'enter real name',
            IDNO: 'ID number',
            IDNOPlace: 'enter ID number',
            successTips1: 'success! bonus release please check My Promotion 。',
            successTips2: 'Success real-name verification',
            nameValid: 'Do not send again real-name verification. Please contact Customer Support！'
        },
        mobileAuth: {
            title: 'phone authentication',
            phoneError: 'phone number not matched',
            phonePlace: 'enter phone number',
            verifCodePlace: 'enter SMS verification code',
            successTips: 'success verification',
            authenticated: 'the phone no. has verified; do not repeat click'
        },
        emailAuth: {
            title: 'Email authentication',
            tips1: 'We have sent an e-mail with a confirmation link to your email, please click the link to complete register.',
            tips2: 'Note: the email might be mistaken for spam; pls also check the spam folder.。',
            email: 'email address',
            emailError: 'invaild email',
            emailPlace: 'enter email address',
            verifCodePlace: 'enter verification code',
            codeSuccess: ' Sent verification code',
            successTips: 'email success',
            authenticated: 'Email has been authenticated, please do not repeat authentication'
        },
        editPwd: {
            title: 'Change Password',
            tips: 'You can reset the password below or contact customer service for further assistance',
            oldPwdPlace: 'enter old password',
            successTips: 'login password success changed',
            loginOut: 'log in again',
            Current: 'Current Password',
            New: 'नया पासवर्ड',
            confirm: 'Confirm New Password',
            next: 'Update',
            must1: 'न्यू पासवर्ड के समान होना चाहिए',
            must2: 'Must be alphanumeric',
            must3: 'Must be identical to New Withdrawal Pin',
            must4: 'Withdrawal pin must be 6~10 digits',
            must5: 'लंबाई से अधिक  5',
            must6: 'Length longer need 5 - 13',
            must7: 'पासवर्ड 8 ~ 20 अल्फ़ान्यूमेरिक होना चाहिए।',
            Required: 'आवश्यक',
            please: 'Please fill in the information to proceed this action',
            Confirmed: 'कृपया नए रूपया निकासी पिन की फिर से पुष्टि करें।',
            PlayerIDTaken: 'This Player ID is taken',
            correctname: 'Please enter a correct name',
            PhoneNumber: 'Phone number cannot be started with 0 or format error',
            tips1: '5~13 अल्फ़ान्यूमेरिक होना चाहिए',
            tips2: 'अमान्य ईमेल पता, कृपया पुनः प्रवेश करें'
        },
        withdrawPwd: {
            title: 'New Withdraw Pin',
            pwdPlace: 'enter old password',
            newPwdPlace: 'enter new password',
            tips: 'Forgot your withdraw password? please contact Customer Support',
            successTips: 'withdraw password success created'
        },
        laest_D: {
            cancel_B: 'Are you sure to cancel the deposit?',
            revoke: 'Revoke',
            revoked: 'Your deposit transaction has been revoked.',
            Reminder: 'Reminder: Multiple cancellation of deposit transactions will cause your account to be suspended.',
            Friendly: 'Friendly reminder',
            Youslip: 'You still have unapproved deposits, please wait for approval or cancel your deposit slip',
            TimeUp: 'Time up! Kindly re-submit your deposit form',
            confirmed: 'confirmed',
            no: 'no',
            yes: 'yes',
            orderNo: 'orderNo',
            Date: 'Date',
            Type: 'Type',
            Amount: 'Amount',
            ID: 'ID',
            status: 'स्थिति',
            action: 'Action'
        },
        Service: 'Please Contact Customer Service',
        gHistory: {
            ProductType: 'उत्पाद प्रकार',
            All: 'सब',
            unsettlement: 'अस्थि',
            settlement: 'बसे हुए'
        },
        MerchRecord: {
            ActivityReward: 'Activity Reward',
            More: 'More',
            Pending: 'Pending',
            Successed: 'Successed',
            Expired: 'Expired',
            Canceled: 'Canceled',
            Processing: 'Processing',
            Succeeded: 'Succeeded',
            Failed: 'Failed',
            Totaldeposit: 'कुल जमा ',
            Totalwithdrawal: 'कुल निकासी',
            TotalPromotion: 'कुल प्रमोशन'
        },
        promo: {
            Expired: 'Expired',
            Processing: 'Processing',
            Claimed: 'Claimed',
            Rejected: 'Rejected',
            Approved: 'Approved',
        }
    },
    wheel: { // 抽奖转盘
        title: 'भाग्यशाली पहिया खेलें',
        smalltitle: 'पैसे कैसे कमाएं',
        lotteryNum: 'शेष रहे',
        lotterySize: 'आवृत्ति',
        winRecord: 'मेरा विजयी इति',
        noRecord: 'कोई डेटा नहीं',
        dispatched: 'इनाम भेजा गया',
        winPrize1: 'क्या सौभाग्य है! आपने एक पुरस्कार जीता है',
        winPrize2: 'बड़ी जीत!',
        sendPrize: 'इनाम भेजा गया।कृपया लेनदेन रिकॉर्ड की जांच करें',
        prizeTips: 'दावा करने के लिए ग्राहक सहायता से संपर्क करें',
        noPrizeNum: 'शेष ड्रा की संख्या: ',
        prizeIng: 'आरेखण प्रगति। ऐसा न करेंबार-बार क्लिक करेंें',
        congratulation: 'कोंग्रटुलतिओन',
        prizeInfo: 'जानकारी जीतना',
        thanksJoin: 'भागीदारी के लिए धन्यवाद',
        lotterNeed: 'लकी ड्रॉ नोट',
        rules: 'गतिविधि नियम',
        start: 'शुरूें',
        gameName: 'भाग्य का पहिया',
        history: 'रिकॉर्ड जीतना',
        needLogin: 'आप आकर्षित करने के लिए लॉग इन कर सकते हैं !',
        WinningRecord: 'विनिंग  रिकॉर्ड ',
        name: 'प्लेयर  ID',
        Awards: 'अवार्ड्स',
        Time: 'विनिंग  टाइम ',
        Status: 'स्टेटस',
        tips: 'अनुस्मारक',
        continue: 'ड्रा  अगेन ',
        goodLuck: 'बेस्ट  ऑफ़  लक  !',
        AwardList: 'पुरस्कार सूची',
        RecentBonus: 'हालिया बोनस',
        Date: 'तारीख',
        Type: 'प्रकार',
        Amount: 'मात्रा',
        More: 'अधिक',
        Close: 'बंद करना',
        View: 'देखना',
    },
    betting: {
        title: 'GT Lottery',
        lottery: 'Lottery',
        stopBet: 'Bets are not allowed in the closed market',
        betMinAmount: 'Min bet amount',
        needLogin: 'You are not logged in yet!',
        AvailableBalance: 'available balance',
        betSuccess: 'success！',
        recharge: 'reload',
        inLottery: 'waiting for draw',
        rule: 'rules',
        issues: 'issue',
        rules: 'betting rules',
        betSubmit: 'place bet',
        addcart: 'add to cart',
        cart: "cart",
        cartTitle: "Shopping Cart",
        clear: 'Clear',
        add: 'Join',
        totalTxt: 'कुल',
        noselected: 'select lucky numbers!',
        noEnoughMoney: 'no enough balance!',
        limitMix: "Betting amount cannot be less than minimum required amount",
        showBtn: "Show Betslip",
        btnNum: "Selections",
        recordType: {
            BTC: "BTC/USDT",
            LTC: "LTC/USDT",
            ETH: "ETH/USDT",
            USDT: "USDT",
        },
        recordItme: {
            betTime: "betting time",
            ticketsNumber: "tickets number",
            betNumber: "bet number",
            amount: "amount",
            drawNumber: "draw number",
            rewards: "rewards"
        },
        betType: "Bet type",
        betStatus: "Bet status",
        done: "Done",
        limitMix: "Betting amount cannot be less than minimum required amount",
        statistical: "Last Results",
        onlinePlayer: "Online Player",
        openOrder: "Number of Buyer",
        openOrderVolume: "Draw Amount",
        newjoinPerson: "Number of people purchased",
        settleType: {
            all: 'all',
            noSettle: 'unsettle',
            settle: 'settle',
            win: 'win',
            lose: 'lose'
        },
        trafficList: {
            0: 'Number',
            10: 'Red',
            11: 'Yellow',
            12: 'Blue',
        },
        cartHead: {
            type: 'type',
            details: 'details',
            multiple: 'multiple',
            money: 'amount'
        },
        lotteryTab: {},
        countDown: 'count down',
        record: {
            title1: 'Draw history',
            title2: 'My betting history',
            title: 'Betting details',
            orderNo: 'tickets number',
            betMoney: 'bet amount',
            dealMoney: 'amount',
            serviceAmount: 'service fee',
            drawNum: 'draw number',
            betNum: 'bet number',
            status: 'स्थिति',
            rewards: 'rewards',
            betTime: 'betting time',
            tableHead: {
                Period: 'Tier number',
                Price: 'Jackpot',
                Numbers: 'Draw Numbers',
                Result: 'Results'
            }
        },
        betChart: {
            title: 'Lottery Trend Chart',
            periodsNum: 'issue',
            lotteryNum: 'lottery number',
            statics: {
                showCount: 'show count',
                averageMiss: 'average miss',
                miss: 'miss',
                maxShwo: 'max show',
                maxMiss: 'max miss'
            },
        },
        mybetTxt: "My Bets",
        seeAll: "See All",
        amountTxt: "Bet Slip",
        editAmout: "Edit quick amount",
        fast: "Fast",
        bets: "bets",
        totolNum: "Total Bet Slip",
        totolAmount: "Total Bet Amount",
        comfirmBet: "Confirm Bets",
    },
    games: {
        all: "See All",
        title: 'Games',
        play: 'Play Now',
        acount: 'Game account',
        amount: "Amount balance",
        stayTuned: 'Stay Tuned',
        collectSuccess: 'Collection success!',
        collectCancel: 'Canceled collection!',
        hotGameType: {
            HotGame: 'Hot Games',
            Live: 'Live Casino',
            Sport: 'Sports',
            Slot: 'Slots',
            CatchFish: 'Catch Fish'
        }
    },
    home: {
        tabOptions: {
            IPL: 'ICC',
            Sport: 'स्पोर्ट्स बुक',
            Crash:'टकरा जाना',
            Live: 'लाइव कैसिनो',
            Slot: 'Slots',
            Mobile: 'APP',
            Promotion: 'Promotion',
            Affiliate: 'एफिलिएट',
            Chess: 'Chess',
            Lottery: 'Lottery',
            Fish: 'Catch Fish',
            Reward: 'Reward',
            InviteFriends: 'Invite Friends',
        },
        contactus: 'संपर्क करें',
        service: "Service",
        welcome: 'EK.BET आपका स्वागत हैl'
    },
    depositHistory: {
        title: 'जमा रिकॉर्ड'
    },
    withdrawalHistory: {
        title: 'Withdrawal Records'
    },
    bankpay: {
        caccountid: 'Please Select Beneficiary Account',
        amount: 'Amount',
        deposittype: 'Deposit Method',
        depositname: 'Depositor Name',
        Transferfrom: 'Transfer from',
        playerdeposittime: 'Deposit Time',
        remarks: 'remarks',
        remarks2: 'Remarks',
        depositimage: 'Upload Deposit Proof'
    },
    ekdeposit: {
        title: 'Deposit Type',
        button: {
            Save: 'Save',
            Deposit: 'जमा रिकॉर्ड',
            Close: 'Close',
            Cancel: 'Cancel',
            Complete: 'Complete transfer',
        },
        countdown: {
            tips: 'Please complete within the time limit, otherwise this order will be canceled'
        },
        bank: {
            title: 'BANK TRANSFER',
            caccountid: 'Please Select Beneficiary Account',
            caccountidRes: 'Please Select Rupeelink Account',
            amount: 'Amount',
            deposittype: 'Deposit Method',
            depositname: 'Depositor Name',
            Transferfrom: 'Transfer from',
            playerdeposittime: 'Deposit Time',
            remarks: 'remarks',
            depositimage: 'Upload Deposit Proof',
            TheMini: 'The minimum amount is ',
            TheMax: 'The maximum amount is ',
            TransferTo: 'Transfer to'
        },
        request: {
            title: 'Deposit request',
            description: 'Your deposit request is sent',
            orderNo: 'Txn. ID',
            orderAmount: 'Amount',
            Time: 'Submit Time',
            Name: 'Depositor Name',
            Beneficiary: 'Beneficiary',
            AccountName: 'Account Name',
            Upload: 'Upload Deposit Proof',
            Actual: 'Actual amount'
        },
        with: {
            PayGate: 'Pay Gate',
            DepositQuota: 'Deposit quota',
            ConvertAmt: 'Convert Amt',
            AccountInfo: 'Account Info',
            ONLINE: {
                tips1: 'Please make a payment in the pop-up window. Be sure to wait until the "Payment Successful" page comes out before closing the page.',
                tips2: 'If the deposit is not successful within the time limit, you will not be able to continue to submit the deposit slip',
                tips3: 'Remind you: Failure or cancel your ticket may result in account suspension',
            }
        },
        Information: {
            Collection: 'Collection Account',
            Name: 'Account Name',
            Transfer: 'Transfer Information',
            Ubank: 'Your bank account',
            Amount: 'Amount',
            FEE: 'FEE',
            Fees: 'Withdrawal Fees',
            usdtAmountTip:'When transferring money, please transfer the entire amount with decimal points, otherwise the transfer will not be successful.'
        },
        PaymentTutorial: {
            title: 'Payment Tutorial',
            tips1: '1. Choose your payment gate > Fill in the deposit amount > Send.',
            tips2: '2. Please fill in the deposit information after the Third party payment page appears .',
            tips3: '3. To prevent any error, please remain on the Third party payment page until the "Payment Success" message pop up.',
            tips4: '4. After review with the 3rd party payment, your wallet credit will be top up automatically by the system.',
            tips5: '5. You may contact the Online Customer service if you meet any trouble or failure.'
        },
        rules: {
            Required: 'आवश्यक',
        }
    },
    fastPay:{
        title:'Payment Tutorial',
        name:"Depositor's name",
        namePlace:"Please enter the depositor's name",
        nameAlert:"To ensure timely payment, please be sure to enter the correct name of the depositor",
        chooseArea:'Select range',
        chooseAreaTips:'The system will select the deposit amount according to the interval, so as to get the account quickly',
        chooseMoney:'Extremely fast deposit amount',
        hasPayTimes:'Number of times this payment method can be used today:',
        times:'times',
        nowDeposit:'Deposit now',
        Previous:'Previous',
        paymentTips:'Please complete the payment within the time limit, otherwise the order will be cancelled.',
        reminder:'Important reminder',
        transferAmount:'Transfer Amount',
        transferAmountTip:'The transfer amount must be consistent with the order amount',
        copy:'copy',
        bankName:'Transfer Bank:',
        bankAccount:'Bank Account:',
        PayeeName:'Payee Name:',
        IFSCcode:'IFSC code:',
        confirmationPayment:'Upload screenshot confirmation payment',
        cancelPayment:'Cancel payment',
        contactService :'Contact Customer Service',
        uploadCertificate:'upload certificate',
        uploadCertificateTip:'Please upload a screenshot of your payment voucher',
        uploadCompleteInformation :'1. Please upload the complete information recovery order of this deposit,',
        uploadCompleteInformationRequire:'Including the complete card number (card number does not include*), amount, name and bank seal',
        returnExample:'Return Single Example',
        returnExampleRequire:'Upload pictures or videos,',
        clickToUpload:'Click to upload',
        Underload:'Underload',
        imageFormat:'Image format',
        imageRequire:'only png, jpg, jpeg can be uploaded',
        uploadDeposit:'2. Please upload the bank card on the day of this deposit',
        RevenueAndExpenditure:"Revenue and expenditure (the bank's income and expenditure details of the start time to the feedback time)",
        uploadPictures:'Upload pictures or videos,',
        UploadConfirmationPayment:'Upload voucher confirmation payment',
        havePaid:'I have paid and cannot upload the voucher',
        orderSubmitted:'The order has been submitted',
        successfullyVoucher:'You have successfully uploaded the voucher and confirmed the payment. Please wait patiently to get the account. If you don’t get the account for 10 minutes, please contact the online customer service',
        orderNo:'Order Number:',
        orderStatus:'Order Status',
        Information:'Information',
        remind:'*remind*',
        urgeOrders :'I want to urge orders',
        warmTips:'You still have a deposit order that has not been paid, please complete the payment first!',
        warmReminder:'Warm reminder',
        confirm:'confirm',
        busySpeedChannel:'Due to the busy speed channel, it is recommended that you use other channels to make deposits.',
        fillName:'Please fill in the name of the deposit first',
        fillAmount:'Please select the deposit amount',
        uploadFailed:'Upload failed, please try it later!',
        uploading:'uploading',
        cannotUploadTip:'If you cannot upload a certificate, please click [Contact Customer Service] to submit the voucher.',
        uploadHasFailed:'upload failed',
        copySuccess:'copy success',
        orderOutTime:'The order exceeds the confirmation time, please contact the customer service',
        voucherFirst:'Please upload the voucher first',
        waitPatiently:'It has been informed that finance confirms the deposit as soon as possible, please wait patiently',
        Isee:'I see',
        continueContact:'Continue contact customer service',
        networkError:'Network error, please try again later',
        fastpayTips1:'1.Select the required payment channel, enter your real name>Select the range of required deposit amount>Select the deposit amount>Deposit immediately',
        fastpayTips2:'2.After depositing immediately, wait for the payment page to appear, and transfer the amount that needs to be recharged to the payment account.',
        fastpayTips3:'3.After the transfer is successful, upload a screenshot of the payment voucher. Click "I paid" to complete the transaction.',
        fastpayTips4:'4.After completion, wait for the financial review. After the review is passed, the system will automatically top up the funds and enter your wallet.',
        fastpayTips5:'5.If you encounter any problems or failures, you can contact online customer service.',
        payGate: 'Pay Gate',
        todayTimes:'times',
        notMatch:'The file format does not match, please upload',
        isee:'I see',
        continueService:'Continue contact customer service',
        contactService2:'contact me',
        ipaid:'I Paid',
        depositRequist:'Your deposit request is sent',
        save:'Save',
        UPIID: 'UPI ID',
    },
    ekwithdraw: {
        botton: {
            Withdraw: 'निकासी',
            bookWithdraw:'निकासी बुक करें',
            Cancel: 'Cancel',
            Yes: 'Yes',
            OK: 'OK'
        },
        title: 'सशर्त निकासी स्थिति',
        noData: 'No Information',
        bookwithdraw:{
            UPIID: 'UPI ID',
            title:'Book a withdrawal',
            time:'Book withdrawal time',
            amount:'Withdrawal amount',
            amountAvabile:'Amount available to withdraw Rs ',
            integerMultiple:'Please enter an integer or multiple of 100',
            amountMoney:'Please enter the withdrawal amount',
            withdrawPWD:'Enter withdrawal password',
            AccountsReceivable:'Accounts receivable',
            addBank:'Add a bank card',
            paymentAccount:'Please select your payment account',
            WithdrawMoneyNow:'Withdraw money now',
            withdrawSet:'If the withdrawal password is not set, do you set it?',
            submit:'confirm',
            cancle:'cancle',
            phoneAuthentication:'A withdrawal needs to complete the mobile phone authentication first, is it authenticated?',
            donotDecimal:'Do not enter a decimal',
            notavalibleMoney:'Can mention insufficient balance',
            selectBank:'Please choose a bank',
            tixianMoney:'The amount is mentioned in',
            aboveMoney:'the above can be withdrawn',
            waitReview:'The withdrawal application is successful, waiting for review',
            enterPSD:'Please enter the withdrawal password',
            Refresh:'Refresh success',
            backMoney:'take out success',
            Setup:'Set up',
            Setuplater:'Set up later',
            processLater:'In the process of processing, please later',
            selectOrderTime:'Please select a time to withdraw money to withdraw money',
            multiple:'Must enter the multiple of 100',
            selectBankCard:'Please select a bank card',
            Gotoview:'Go to view',
            confirmedAccount :'You have confirmed the account, please do not click on.',
            ConfirmSuccess:'Confirm success',
            networkError:'Network error, please try again later!',
            copySuccess :'copy success',
            return:'return',
            waitForPay:'Waiting for payment',
            waitForPayTips:'You have an appointment withdrawal order that is being processed. We are working hard to process your order. Please wait patiently!',
            Confirmarrival:'Confirm arrival',
            ConfirmarrivalTip:'Your scheduled withdrawal order has been paid out. Please check the amount carefully and confirm the payment after confirming it is correct!',
            orderComplete:'order complete',
            orderNumber:'Order Number',
            copy:'copy',
            // amount:'Amount',
            status:'Withdrawal Status',
            waitConfirm:'Waiting for your confirmation',
            orderSubmitted:'The order has been submitted',
            bankCard:'Transfer bank',
            BankAccount:'Bank Account',
            TransferName:'Transfer name',
            openingBranch:'Account opening branch',
            withdrawProgess:'Withdrawal progress: your appointment time',
            success:'success',
            Processing:'Processing…',
            Return:'Return',
            receivingPayment:'After receiving the payment, click to confirm the payment and you will get the reward immediately',
            receivingPayment1:'After receiving the payment, click',
            receivingPayment2:'to confirm the payment and you will get the reward immediately',
            hasWithdrawalOrder:'You have a withdrawal order in the reservation, please complete the reservation first!',
            paidOut:'has been paid out',
            withdrawalBankCard:'Withdrawal Bank Card',
        },
        WithdrawalList: {
            Period: 'Period',
            AuditType: 'Audit type',
            Deposit: 'Deposit',
            Bonus: 'Bonus',
            VliadBets: 'Vliad Bets',
            ValidBetsCond: 'Valid Bets Cond',
            Status: 'स्थिति',
            status0: 'Yet to fulfill',
            status1: 'Passed'
        },
        applyWithdraw: {
            amount: 'Withdraw Amount',
            userBankId: 'Beneficiary account',
            withdrawPWD: 'Withdrawal Pin',
            info: 'Deduct total conditions 0.00',
            amountmessage: 'Withdraw amount need to be between 500.00 and 500.00',
            amountmessage2: 'Withdraw amount need to be between ',
            and: 'and',
            UBank: 'Bank Account Number',
            withdrawGamesTips: 'This action will transfer all available balance to main wallet, continue?',
            addcartTips: 'Please Add Your Bank Account',
            setpinTips: 'Please Set Your Withdrawal Pin',
            AvailBalance: 'Amount available to withdraw',
            please1: 'Withdrawal pin must be 6~10 digits',
            please2: 'Please remember your withdrawal pin',
            confirm: 'Confirm Withdrawal Pin',
        },
        request: {
            title: 'Withdrawal Request',
            tips: 'Withdrawal Request Submitted!',
            description: 'Withdrawal request might take some times to process.You may always follow up with our online support for thewithdrawal status.',
            Time: 'Date',
            Beneficiary: 'Beneficiary Name',
            RupeelinklAmount: 'Rupeelink Amount',
            WithdrawalAmount: 'Withdrawal Amount',
            ActualAmount: 'Actual Amount',
            orderNo: 'Txn. ID',
            REsdNumber: 'Rupeelink Account',
            Records: 'W/D Records'
        }
    },
    ekgamehistory: {
        title: 'Game History',
        subtitle: '*Access to the data may be delayed, if no game record, please try again later The overview data is summed up at GMT+8 generally, and only shows the data for the last 10 days.',
        tabs: {
            Overview: 'Overview',
            SportsBook: 'स्पोर्ट्स बुक',
            LiveGames: 'लाइव कैसिनो',
            Chess: 'शतरंज',
            Slots: 'स्लॉट्स',
            all: 'All',
            Running: 'Running',
            Settled: 'बसे हुए',
        },
        Provider: 'Provider',
        Allproviders: 'सभी खेल प्रदाता',
        Status: 'स्थिति',
        label: {
            Bettime: 'Bet time',
            SettleTime: 'Settle Time',
            ID: 'Txn. ID',
            RoundID: 'Round ID',
            Provider: 'Provider',
            Game: 'खेल',
            Odds: 'Odds',
            TotalBets: 'कुल दांव',
            ValidBets: 'Valid Bets',
            WinorLoss: 'Win/Loss',
            Status: 'स्थिति',
            TotalValidBets: 'Total Valid Bets',
            bet: 'Bet',
            Event: 'Event',
            betArea: 'Bet area',
            gameName: 'Game name',
        },
        loading: {
            title: 'Bet Detail',
            Playerid: 'Player ID',
            gameid: 'Game ID',
            insurance: 'insurance',
            WinorLoss: 'कुल जीत / हार'
        }
    },
    ekfinanHistory: {
        title: 'वित्तीय रिकॉर्ड',
        nav: {
            Deposit: 'Deposit',
            Withdrawal: 'वापसी',
            Promotion: 'Promotion',
            Rebate: 'रीबेट रिकॉर्ड',
            ActivityReward: 'Activity Reward',
            Affiliate: 'Affiliate',
            Rupeelink:'Rupeelink',
            Turnover:'Turnover'
        },
        table: {
            Status: 'स्थिति',
            Date: 'Date',
            Remark: 'Remark',
            Type: 'Type',
            Amount: 'Amount'
        },
        depositlable: {
            DepositType: 'Deposit Type',
            Amount: 'Amount',
            ID: 'Txn. ID',
            Action: 'Action',
        },
        withdrawtable: {
            Bank: 'Bank',
            RequestedAmount: 'Requested Amount',
            ActualAmount: 'Actual Amount',
            BankAccount: 'Bank Account',
            BankAccount2: 'Bank Account Number',
            bkNbrules: 'Must be 6 ~ 22 digits',
            filter: {
                Pending: 'Pending',
                Applying: 'Applying',
                Succeeded: 'Succeeded',
                RiskRejected: 'Refused',
                Processing: 'Processing',
                Rejectede: 'Rejectede',
            }
        },
        Promotion: {
            PromotionName: 'Promotion Name',
            bonusType: {
                0:'Rebates',
                1:'Turnover Bonus',
                2:'Deposit Bonus',
                3:'Invitation Bonus',
                4:'Check In Bonus',
                5:'Other Bonus',
            },
            bonusStatus: {
                0: '申请中',
                1: '进行中',
                2: '成功发放',
                3: '拒绝',
                4: '失败',
                5: 'Unclaimed',
                6: '未抽中',
                7: '已经过期',
            }
        },
        Rebate: {
            RebateName: 'Rebate Name',
        },
        Activity: {
            DrawDate: 'Draw Date',
            ActivityType: 'Activity Type',
            ActivityName: 'Activity Name',
            RewardType: 'Reward Type',
            Reward: 'Reward',
        }

    },
    ekinbox: {
        title: 'संदेश',
        Private: 'निजी सन्देश',
        General: 'General',
    },
    ekinvitation: {
        title: 'Invite Friends',
        QRtitle: 'Scan to download APP',
        Affiliateslink: 'Affiliates link',
        DownloadAPP: 'Download APP',
        ReferralCode: 'Referral Code',
        Affiliates: 'Friend can choose any of the register methods.',
        PromotionDetails: 'Promotion Details',
        table: {
            Account: 'खाता',
            Time: 'Time',
            Status: 'स्थिति',
            Receive: 'Receive'
        }
    },
    walletlialog: {
        WALLET: 'Wallet',
        Deposit: 'deposit',
        Withdraw: 'निकासी',
        WalletDetails: 'details',
        MainAccount: 'Main Wallet',
        Cancel: 'close',
        NoDate: 'No gaming account found',
        refreshsuccess: 'Balance Refreshed'
    },
    form: {
        addOne:'At least 4 characters',

        checkMoney1:'enter amount',
        checkMoney2:'format error',
        checkMoney3:'amount cannot be 0',
        //
        checkWithdraw:'enter withdraw password',
        //
        checkRealname:'enter real name',
        /**Verify bank card*/
        checkBankNumber1:'enter bank account',
        checkBankNumber2:'bank card format error',
        /** Verify branch*/
        checkBranch:'enter the accounts bank branch',
        /** Check email */
        checkEmail1:'enter Email address',
        checkEmail2:'Email format error',
        /** Verify ID */
        checkCard1: 'enter ID no.',
        checkCard2: 'ID no. format error',
        /**Check mobile phone number*/
        checkPhone1: 'enter phone no.',
        checkPhone2: 'enter vaild phone no.',
        /** verify password */
        checkPassword:'enter password',
        /** Verify the password */
        checkConfirm1: 'enter password again',
        checkConfirm2: 'password does not match',
        /** Verify the original password to confirm the password */
        checkConfirms: 'old and new password are the same',
        /**Verify verification code*/
        checkVerifiCode1: 'verification code not empty',
        checkVerifiCode2: 'verification code format error',
        /** Verify account */
        checkUsername1: 'enter username',
        checkUsername2:'password containing 6-12 letters, no., or a combination.',
        /**Verify multi-country numbers*/
        checkPhoneNumber1:'enter a vaild phone no.',
        checkPhoneNumber2:'enter phone no.',
        /** Verify registration password */
        checkRegisterPassword1:'enter login password',
        checkRegisterPassword2:'password containing 6-12 letters, no., or a combination.',
        /** Verify real name */
        checkrealName1:'real name not empty',
        checkrealName2:'No less than two characters',
        /** verify qq */
        checkQQ1:'QQ not empty',
        checkQQ2:'No less than six characters',
        /** Check WeChat */
        checkwechat1:' WeChat not empty',
        checkwechat2:'Not less than ten characters',
        /** Check email */
        checkemail1:'Email not empty',
        checkemail2:'Not less than 13 characters and more than 20 characters',
        checkemail3:'enter a vaild email address',
        /** Verify withdrawal password */
        checkwithdrawPassword1:'withdraw password not empty',
        checkwithdrawPassword2:'Not less than six characters',
        checkBankName:'Bank account not verified, please try later',
        /** 校验提款密码 */
        checkNumber1:'please input amount',
        checkNumber2:'invalid amount，please input whole number',
        checkNumber3:'amount cannot be 0',
        /** 支付金额 **/
        checkPayMoney1:'PLEASE ENTER TOP UP AMOUNT',
        checkPayMoney2:' INCORRECT AMOUNT FORMAT',
        checkPayMoney3:'DEPOSIT LIMIT{min} - {max} INR',
    },
    ekVip:{
        powerList:{
            Upgrade:'अपग्रेड बोनस',
            Birthday:'जन्मदिन बोनस',
            Weekly:'साप्ताहिक बोनस',
            Month:'महीने का बोनस',
            Monthly:'मासिक सहायता',
            spin:'पुरस्कृत भाग्यशाली स्पिन',
            subUpgrade:"कुल पुरस्कार: <span class='num'>{num}</span>",
            subBirthday:"कुल पुरस्कार: <span class='num'>{num}</span>",
            subWeekly:"अपने पिछले सप्ताह की जमा राशि के आधार पर टीपी <span class='num'>{num}</span> तक बोनस प्राप्त करें",
            subMonth:"अपने पिछले महीने की जमा राशि के आधार पर tp <span class='num'>{num}</span> तक बोनस प्राप्त करें",
            subMonthly:"कुल पुरस्कार: <span class='num'>{num}</span>",
            subSpin:"टाइम्स: <span class='num'>{num}</span>",
        },
        CurrentLevel: 'वर्तमान स्तर',
        YourVIPProgress: 'आपकी वीआईपी प्रगति',
        UpgradeDeposit: 'जमा अपग्रेड करें',
        PrivilegeReward: 'विशेषाधिकार पुरस्कार',
        Bromze: 'पीतल',
        Deposit: 'जमा',
        Learn: "EK.BET'S VIP सिस्टम के बारे में और जानें",
        InsufficientLevel: 'अपर्याप्त स्तर',
        CampaignDetails: 'अभियान का विवरण',
    },
    crypto: {
        CryptoWithdrawal: 'क्रिप्टो निकासी',
        RupeelinWithdrawal:'रुपीलिंक निकासी',
        ChooseNetwork: 'नेटवर्क चुनें',
        WithdrawalAddress: 'निकासी पता',
        Fillin: 'विशिष्ट मुद्रा के अनुसार सावधानीपूर्वक भरें',
        rupeelinkFillin:'कृपया अपना वास्तविक नाम दर्ज करें',
        rupeelinkName:'कृपया अपना रुपेलिंक वॉलेट पता दर्ज करें',
        WithdrawAmount: 'राशि वापस ले',
        Available: 'उपलब्ध',
        Lockedfunds: 'अवरुद्ध निधियाँ',
        Withdrawamount: 'राशि वापस ले',
        Convertamount: 'राशि परिवर्तित करें',
        Notice: 'सूचना',
        Forsecuritypurposes: 'सुरक्षा कारणों से, बड़ी या संदिग्ध निकासी की ऑडिट प्रक्रिया में 1 से 5 घंटे लग सकते हैं। हम आपके धैर्य की सराहना करते हैं।',
        Amount: 'मात्रा',
        Crypto: 'क्रिप्टो',
        Address: 'पता',
        WithdrawCurrency: 'मुद्रा वापस लें',
        ConvertAmount: 'राशि परिवर्तित करें',
        addUsdtTips: 'कृपया अपना USDT पता जोड़ें',
        bankManage: "USDT पता प्रबंधन",
        getBankManage:'रुपीलिंक पता प्रबंधन',
        addBankCard: 'USDT पता जोड़ें',
        WithdrawPassword: 'पासवर्ड वापस लें',
        personName: 'खाता धारक का नाम',
        cardNumber: 'रुपीलिंक पता',
        bankName: 'बैंक का नाम',
    },
    404:{
        tips1:'ओह… पेज नहीं मिला, लेकिन आपके पुरस्कार अभी भी यहां हैं!',
        tips2:"होमपेज पर वापस लौटें और आज के मुफ्त स्पिन और बोनस देखें! ",
        return:'होमपेज पर लौटें'
    },
    forceChangePassword:{
        title:'दयालु सुझाव',
        tips:'अपने खाते की सुरक्षा के लिए, कृपया अपना पासवर्ड बदलें',
        go:'संपादित करने के लिए जाएँ'
    },
}
export default en_US



// WEBPACK FOOTER //
// ./src/pages/build821/i18n/langs/hi_IN.js